import { isConfigFlagEnabled } from '../../config';
import { ALL_BUY_IN_RANGES } from '../../types/sharedTypes';
import { getOutboundMessage } from './outboundUtils';
export function createCreateRegularOutbound({ roomName, buyInIndex, buyInRange, gameSpeedIndex, blindsIndex, variantId, currencyIndex, numSeats, isAggroBettingFilterEnabled, isDualLimitEnabled, isSideBetsPhaseEnabled, isPowerPlayersOnly }) {
    return getOutboundMessage({
        _type: 'create_regular_v2',
        parts: [
            { name: 'roomName', stringValue: roomName, needsEncoding: true },
            { name: 'currencyIndex', numberValue: currencyIndex },
            { name: 'buyInIndex', numberValue: buyInIndex },
            { name: 'buyInRangeIndex', numberValue: ALL_BUY_IN_RANGES.indexOf(buyInRange) },
            { name: 'delayIndex', numberValue: gameSpeedIndex },
            { name: 'numSeats', numberValue: numSeats },
            { name: 'variantId', numberValue: variantId },
            {
                name: 'isAggroBettingFilterEnabled',
                booleanValue: !isConfigFlagEnabled('dualLimitGameSetting') ? isAggroBettingFilterEnabled : false
            },
            {
                name: 'isDualLimitEnabled',
                booleanValue: isConfigFlagEnabled('dualLimitGameSetting') ? isDualLimitEnabled : false
            },
            { name: 'maxBuyins', numberValue: 5 },
            { name: 'allowAutoReloadBuyin', booleanValue: true },
            { name: 'blindsIndex', numberValue: blindsIndex },
            { name: 'isPowerPlayerOnly', booleanValue: isPowerPlayersOnly },
            { name: 'isEnglishOnly', booleanValue: false },
            {
                name: 'isSideBetsPhaseEnabled',
                booleanValue: isConfigFlagEnabled('sideBets') ? isSideBetsPhaseEnabled : false
            },
            { name: 'welcomeMessage', stringValue: '', needsEncoding: true }
        ]
    });
}
export function createCreateSttOutbound({ roomName, buyInIndex, gameSpeedIndex, variantId, currencyIndex, numSeats, isPowerPlayersOnly }) {
    return getOutboundMessage({
        _type: 'create_stt',
        parts: [
            { name: 'roomName', stringValue: roomName, needsEncoding: true },
            { name: 'currencyIndex', numberValue: currencyIndex },
            { name: 'buyInIndex', numberValue: buyInIndex },
            { name: 'delayIndex', numberValue: gameSpeedIndex },
            { name: 'numSeats', numberValue: numSeats },
            { name: 'variantId', numberValue: variantId },
            { name: 'isPowerPlayerOnly', booleanValue: isPowerPlayersOnly },
            { name: 'isEnglishOnly', booleanValue: false },
            { name: 'welcomeMessage', stringValue: '', needsEncoding: true }
        ]
    });
}
export function createCreateMttOutbound({ roomName, buyInIndex, gameSpeedIndex, variantId, currencyIndex, numMttSeats, isPowerPlayersOnly }) {
    return getOutboundMessage({
        _type: 'create_mtt',
        parts: [
            { name: 'roomName', stringValue: roomName, needsEncoding: true },
            { name: 'currencyIndex', numberValue: currencyIndex },
            { name: 'buyInIndex', numberValue: buyInIndex },
            { name: 'delayIndex', numberValue: gameSpeedIndex },
            { name: 'numSeats', numberValue: numMttSeats },
            { name: 'variantId', numberValue: variantId },
            { name: 'isPowerPlayerOnly', booleanValue: isPowerPlayersOnly },
            { name: 'isEnglishOnly', booleanValue: false },
            { name: 'allowChipUps', booleanValue: false },
            { name: 'welcomeMessage', stringValue: '', needsEncoding: true }
        ]
    });
}
export function createCreateAllInsanityOutbound({ roomName, buyInIndex, buyInRange, gameSpeedIndex, currencyIndex, numSeats }) {
    return getOutboundMessage({
        _type: 'create_all_in',
        parts: [
            { name: 'roomName', stringValue: roomName, needsEncoding: true },
            { name: 'currencyIndex', numberValue: currencyIndex },
            { name: 'buyInIndex', numberValue: buyInIndex },
            { name: 'buyInRangeIndex', numberValue: ALL_BUY_IN_RANGES.indexOf(buyInRange) },
            { name: 'delayIndex', numberValue: gameSpeedIndex },
            { name: 'numSeats', numberValue: numSeats },
            { name: 'isEnglishOnly', booleanValue: false }
        ]
    });
}
export function createLobbyChatOutbound(message) {
    return getOutboundMessage({ _type: 'lc', parts: [{ name: 'message', stringValue: message }] });
}
export function createJoinOutbound(roomId) {
    return getOutboundMessage({
        _type: 'join',
        parts: [
            { name: 'roomId', numberValue: roomId },
            { name: 'isShiftKeyDown', booleanValue: false } // TODO: maybe add support for shift
        ]
    });
}
export function createInitLobbyOutbound() {
    return getOutboundMessage({
        _type: 'init_lobby',
        parts: [
            { name: 'promoCode', stringValue: '' },
            { name: 'promoJacksCode', stringValue: '' }
        ]
    });
}
export function createRequestResetPasswordOutbound(usernameOrEmail) {
    return getOutboundMessage({
        _type: 'request_reset_password',
        parts: [{ name: 'usernameOrEmail', stringValue: usernameOrEmail }]
    });
}
export function createUpdateMttFromIdOutbound(mttId) {
    return getOutboundMessage({
        _type: 'update_mtt_from_id',
        parts: [{ name: 'mttId', numberValue: mttId }]
    });
}
export function createSetDisconnectionBehaviorOutbound(disconnectionBehavior) {
    return getOutboundMessage({
        _type: 'set_disconnection_behavior',
        parts: [{ name: 'disconnectionBehavior', stringValue: disconnectionBehavior }]
    });
}
